import { useContext } from 'react';
import type { FamilyMember } from '../api/familyApi';
import { FamilyContext } from '../contexts/familyContextStore';

export const useFamily = () => {
  const ctx = useContext(FamilyContext);
  if (!ctx) {
    return {
      activeUserId: null,
      setActiveUserId: () => {},
      familyMembers: [] as FamilyMember[],
      loading: false,
      refreshFamilyMembers: async () => {},
      selfMember: null,
      isFamilyEnabled: false,
    };
  }
  return {
    ...ctx,
    isFamilyEnabled: ctx.familyMembers.length >= 0,
  };
};
